var map = {
	"./agentes/agentes.module": [
		"./src/app/components/catalogos/agentes/agentes.module.ts",
		"common",
		"agentes-agentes-module"
	],
	"./almacenes/almacenes.module": [
		"./src/app/components/catalogos/almacenes/almacenes.module.ts",
		"common",
		"almacenes-almacenes-module"
	],
	"./articulos/articulos.module": [
		"./src/app/components/catalogos/articulos/articulos.module.ts",
		"articulos-articulos-module"
	],
	"./categoria-productos/categoria-productos.module": [
		"./src/app/components/catalogos/categoria-productos/categoria-productos.module.ts",
		"common",
		"categoria-productos-categoria-productos-module"
	],
	"./categorias-articulos/categorias-articulos.module": [
		"./src/app/components/catalogos/categorias-articulos/categorias-articulos.module.ts",
		"categorias-articulos-categorias-articulos-module"
	],
	"./clientes/clientes.module": [
		"./src/app/components/catalogos/clientes/clientes.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"clientes-clientes-module~components-facturas-facturas-module~components-ordenes-ordenes-module~compo~24394548",
		"clientes-clientes-module~colores-colores-module~components-ecommerce-ecommerce-module",
		"common",
		"clientes-clientes-module"
	],
	"./colores/colores.module": [
		"./src/app/components/catalogos/colores/colores.module.ts",
		"clientes-clientes-module~colores-colores-module~components-ecommerce-ecommerce-module",
		"common",
		"colores-colores-module"
	],
	"./components/bitacora-produccion/bitacora-produccion.module": [
		"./src/app/components/bitacora-produccion/bitacora-produccion.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"common",
		"components-bitacora-produccion-bitacora-produccion-module"
	],
	"./components/catalogos/catalogos.module": [
		"./src/app/components/catalogos/catalogos.module.ts",
		"components-catalogos-catalogos-module"
	],
	"./components/configuracion-produccion/configuracion-produccion.module": [
		"./src/app/components/configuracion-produccion/configuracion-produccion.module.ts",
		"components-configuracion-produccion-configuracion-produccion-module"
	],
	"./components/dashboard/dashboard.module": [
		"./src/app/components/dashboard/dashboard.module.ts",
		"common",
		"components-dashboard-dashboard-module"
	],
	"./components/ecommerce/ecommerce.module": [
		"./src/app/components/ecommerce/ecommerce.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~885cf829",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~d8a89326",
		"clientes-clientes-module~colores-colores-module~components-ecommerce-ecommerce-module",
		"common",
		"components-ecommerce-ecommerce-module"
	],
	"./components/facturas/facturas.module": [
		"./src/app/components/facturas/facturas.module.ts",
		"clientes-clientes-module~components-facturas-facturas-module~components-ordenes-ordenes-module~compo~24394548",
		"components-facturas-facturas-module~components-ordenes-ordenes-module",
		"common",
		"components-facturas-facturas-module"
	],
	"./components/inventario-detalle/inventario-detalle.module": [
		"./src/app/components/inventario-detalle/inventario-detalle.module.ts",
		"common",
		"components-inventario-detalle-inventario-detalle-module"
	],
	"./components/inventario-productos/inventario-productos.module": [
		"./src/app/components/inventario-productos/inventario-productos.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"common",
		"components-inventario-productos-inventario-productos-module"
	],
	"./components/inventario/inventario.module": [
		"./src/app/components/inventario/inventario.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~885cf829",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~d8a89326",
		"common",
		"components-inventario-inventario-module"
	],
	"./components/ordenes/ordenes.module": [
		"./src/app/components/ordenes/ordenes.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~885cf829",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~d8a89326",
		"clientes-clientes-module~components-facturas-facturas-module~components-ordenes-ordenes-module~compo~24394548",
		"components-ordenes-ordenes-module~modelos-modelos-module",
		"components-facturas-facturas-module~components-ordenes-ordenes-module",
		"common",
		"components-ordenes-ordenes-module"
	],
	"./components/produccion-dia/produccion-dia.module": [
		"./src/app/components/produccion-dia/produccion-dia.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~885cf829",
		"clientes-clientes-module~components-facturas-facturas-module~components-ordenes-ordenes-module~compo~24394548",
		"common",
		"components-produccion-dia-produccion-dia-module"
	],
	"./components/reportes/reportes.module": [
		"./src/app/components/reportes/reportes.module.ts",
		"common",
		"components-reportes-reportes-module"
	],
	"./components/suscripciones/suscripciones.module": [
		"./src/app/components/suscripciones/suscripciones.module.ts",
		"components-suscripciones-suscripciones-module"
	],
	"./conceptos/conceptos.module": [
		"./src/app/components/catalogos/conceptos/conceptos.module.ts",
		"common",
		"conceptos-conceptos-module"
	],
	"./coordinadores/coordinadores.module": [
		"./src/app/components/catalogos/coordinadores/coordinadores.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"common",
		"coordinadores-coordinadores-module"
	],
	"./descuentos/descuentos.module": [
		"./src/app/components/catalogos/descuentos/descuentos.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"common",
		"descuentos-descuentos-module"
	],
	"./distribuidores/distribuidores.module": [
		"./src/app/components/catalogos/distribuidores/distribuidores.module.ts",
		"common",
		"distribuidores-distribuidores-module"
	],
	"./equipos/equipos.module": [
		"./src/app/components/catalogos/equipos/equipos.module.ts",
		"common",
		"equipos-equipos-module"
	],
	"./jugadores/jugadores.module": [
		"./src/app/components/catalogos/jugadores/jugadores.module.ts",
		"common",
		"jugadores-jugadores-module"
	],
	"./ligas/ligas.module": [
		"./src/app/components/catalogos/ligas/ligas.module.ts",
		"common",
		"ligas-ligas-module"
	],
	"./lineas/lineas.module": [
		"./src/app/components/catalogos/lineas/lineas.module.ts",
		"common",
		"lineas-lineas-module"
	],
	"./maderas/maderas.module": [
		"./src/app/components/catalogos/maderas/maderas.module.ts",
		"common",
		"maderas-maderas-module"
	],
	"./modelos/modelos.module": [
		"./src/app/components/catalogos/modelos/modelos.module.ts",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~885cf829",
		"components-ecommerce-ecommerce-module~components-inventario-inventario-module~components-ordenes-ord~d8a89326",
		"components-ordenes-ordenes-module~modelos-modelos-module",
		"common",
		"modelos-modelos-module"
	],
	"./pallets/pallets.module": [
		"./src/app/components/catalogos/pallets/pallets.module.ts",
		"pallets-pallets-module"
	],
	"./productos/productos.module": [
		"./src/app/components/catalogos/productos/productos.module.ts",
		"common",
		"productos-productos-module"
	],
	"./proveedores/proveedores.module": [
		"./src/app/components/catalogos/proveedores/proveedores.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"common",
		"proveedores-proveedores-module"
	],
	"./representantes/representantes.module": [
		"./src/app/components/catalogos/representantes/representantes.module.ts",
		"clientes-clientes-module~components-bitacora-produccion-bitacora-produccion-module~components-ecomme~0dd1b074",
		"common",
		"representantes-representantes-module"
	],
	"./stickers/stickers.module": [
		"./src/app/components/catalogos/stickers/stickers.module.ts",
		"stickers-stickers-module"
	],
	"./tipo-cliente/tipo-cliente.module": [
		"./src/app/components/catalogos/tipo-cliente/tipo-cliente.module.ts",
		"common",
		"tipo-cliente-tipo-cliente-module"
	],
	"./usuarios/usuarios.module": [
		"./src/app/components/catalogos/usuarios/usuarios.module.ts",
		"usuarios-usuarios-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;